











import Vue from "vue";
import RoomWizard from "@/components/organisms/wizard/RoomWizard.vue";

export default Vue.extend({
  name: "ActivateRoom",
  components: {
    RoomWizard,
  },
});
